import { useEffect, useState } from 'react';

// Handy-Layout (Bedienleiste unten): schmale Bildschirme unter Tailwinds md-Breakpoint,
// Touch-Tablets im Hochformat und Handys im Querformat (wenig Höhe)
const MOBILE_LAYOUT_QUERY = [
  '(max-width: 767px)',
  '(pointer: coarse) and (orientation: portrait)',
  '(pointer: coarse) and (max-height: 500px)',
].join(', ');
// Hauptsächlich per Finger bedient (Handy, Tablet) – unabhängig von der Bildschirmbreite
const TOUCH_QUERY = '(pointer: coarse)';

const matches = (query) =>
  typeof window !== 'undefined' && window.matchMedia(query).matches;

const useMediaQuery = (query) => {
  const [isMatch, setIsMatch] = useState(() => matches(query));

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setIsMatch(e.matches);
    setIsMatch(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return isMatch;
};

export const useMobileLayout = () => useMediaQuery(MOBILE_LAYOUT_QUERY);

export const useIsTouch = () => useMediaQuery(TOUCH_QUERY);
